"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SttPaper = _interopRequireDefault(require("../SttPaper"));
var _SttBox = _interopRequireDefault(require("../../SttLayout/SttBox"));
var _excluded = ["instancia"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    box: {
      top: 0,
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      maxWidth: '100%',
      minWidth: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      borderColor: theme.palette.background.border,
      backgroundColor: theme.palette.background["default"],
      '& a': {
        backgroundImage: 'none',
        background: 'none'
      },
      '& a:not(:disabled):hover': {
        backgroundImage: 'none !important',
        background: 'none !important'
      }
    },
    paper: {
      padding: theme.spacing(1),
      background: theme.palette.background["default"],
      display: 'flex',
      alignItems: 'center',
      height: 50 + theme.spacing(1) * 2 // altura máxima do container da logo
    },
    logoBrasil: {
      height: 50,
      maxHeight: 50,
      width: 'auto',
      display: 'block'
    },
    logoMenor: {
      height: 38,
      maxHeight: 38,
      width: 'auto',
      display: 'block'
    },
    logoQuadrada: {
      height: 80,
      maxHeight: 80,
      width: 'auto',
      display: 'block'
    }
  };
});
var Header = function Header(_ref) {
  var instancia = _ref.instancia,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var isXs = (0, _useMediaQuery["default"])(theme.breakpoints.down('xs'));
  return /*#__PURE__*/_react["default"].createElement(_SttBox["default"], _extends({
    borderBottom: 1,
    className: classes.box
  }, props), instancia && instancia.logo ? instancia.logo.map(function (logo, index) {
    return /*#__PURE__*/_react["default"].createElement(_SttPaper["default"], {
      className: classes.paper,
      key: index
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: logo.link ? logo.link : "javascript:void(0);"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: isXs && logo.srcMobile ? logo.srcMobile : logo.src,
      alt: logo.altText,
      className: logo.brasil ? classes.logoBrasil : logo.quadrada ? classes.logoQuadrada : classes.logoMenor
    })));
  }) : null);
};
Header.propTypes = {
  instancia: _propTypes["default"].object.isRequired
};
var _default = Header;
exports["default"] = _default;